const cities = [
  'Kaboul',
  'Copenhague',
  'Monrovia',
  'Moscou',
  'Prétoria',
  'Djibouti',
  'Tripoli',
  'Kigali',
  'Tirana',
  'Vaduz',
  'Basseterre',
  'Alger',
  'Saint-Domingue',
  'Vilnius',
  'Castries',
  'Berlin',
  'Roseau',
  'Luxembourg',
  'Saint-Marin',
  'Andorre-la-Vieille',
  'Le Caire',
  'Luanda',
  'Abou Dabi',
  'Skopje',
  'Quito',
  'Antananarivo',
  'Kingstown',
  'Riyad',
  'Asmara',
  'Honiara',
  'Buenos Aires',
  'Madrid',
  'Kuala Lumpur',
  'San Salvador',
  'Erevan',
  'Tallinn',
  'Lilongwé',
  'Apia',
  'Canberra',
  'Washington',
  'Malé',
  'Sao Tomé',
  'Vienne',
  'Addis Abeba',
  'Bamako',
  'Dakar',
  'Bakou',
  'Suva',
  'La Valette',
  'Belgrade',
  'Nassau',
  'Helsinki',
  'Rabat',
  'Victoria',
  'Manama',
  'Paris',
  'Delap-Uliga-Darrit',
  'Freetown',
  'Dacca',
  'Libreville',
  'Singapour',
  'Bridgetown',
  'Banjul',
  'Port-Louis',
  'Bratislava',
  'Bruxelles',
  'Tbilissi',
  'Nouakchott',
  'Ljubljana',
  'Belmopan',
  'Accra',
  'Mexico',
  'Mogadiscio',
  'Porto-Novo',
  'Athènes',
  'Palikir',
  'Khartoum',
  'Thimphou',
  'Saint-Georges',
  'Chisinau',
  'Minsk',
  'Guatémala',
  'Monaco',
  'Sri Jayewardenepura Kotte',
  'Naypyidaw',
  'Conakry',
  'Oulan-Bator',
  'La Paz',
  'Bissao',
  'Podgorica',
  'Stockholm',
  'Sarajevo',
  'Malabo',
  'Maputo',
  'Berne',
  'Gaborone',
  'Georgetown',
  'Windhoek',
  'Paramaribo',
  'Brasilia',
  'Port-au-Prince',
  'Yaren',
  'Mbabané',
  'Bandar Seri Begawan',
  'Tégucigalpa',
  'Katmandou',
  'Damas',
  'Sofia',
  'Budapest',
  'Managua',
  'Douchanbé',
  'Ouagadougou',
  'New Delhi',
  'Niamey',
  'Dodoma',
  'Bujumbura',
  'Jakarta',
  'Abuja',
  'Ndjamena',
  'Phnom Penh',
  'Bagdad',
  'Oslo',
  'Prague',
  'Yaoundé',
  'Téhéran',
  'Wellington',
  'Bangkok',
  'Ottawa',
  'Dublin',
  'Mascate',
  'Dili',
  'Praia',
  'Reykjavik',
  'Kampala',
  'Lomé',
  'Bangui',
  'Tachkent',
  'Santiago',
  'Rome',
  'Islamabad',
  'Pékin',
  'Kingston',
  'Melekeok',
  'Tunis',
  'Nicosie',
  'Tokyo',
  'Panama',
  'Achgabat',
  'Bogota',
  'Amman',
  'Port Moresby',
  'Ankara',
  'Moroni',
  'Astana',
  'Asuncion',
  'Brazzaville',
  'Nairobi',
  'Kiev',
  'Bichkek',
  'Amsterdam',
  'Montévidéo',
  'Kinshasa',
  'Lima',
  'Port-Vila',
  'Pyongyang',
  'Pristina',
  'Manille',
  'Caracas',
  'Séoul',
  'Koweït',
  'Varsovie',
  'San José',
  'Vientiane',
  'Lisbonne',
  'Sanaa',
  'Yamoussoukro',
  'Maseru',
  'Doha',
  'Lusaka',
  'Zagreb',
  'Riga',
  'Bucarest',
  'La Havane',
  'Beyrouth',
  'Londres',
]

export default cities
